<osn-cxb-multi-select
  [formControl]="programTypeControl"
  [options]="programTypeOptions"
  filterPlaceholderLabel="Filter in program types..."
  placeholder="Filter in program types..."
  filterNoEntriesFoundLabel="No program type found"
  [data-testid]="testId"
></osn-cxb-multi-select>
